import './style.scss';

export function specialists_block() {

    const block = document.querySelector('.specialists_block');
    if (!block) return;

}
